export default {
  name: 'category-goods',
  label: {
    title: '分类商品',
    icon: require('@/assets/icon-component-label_Goods.png'),
    limit: 1
  },
  sort: 2.1,
  data: {},
  settings: {}
}
